import simpleActionCreator from '../helpers/simpleActionCreator';
import { reducerNames } from '../constants';

export const setShowResetResultModal = simpleActionCreator('setShowResetResultModal', reducerNames.ui, 'showResetResultModal');

export default {
  setShowResetResultModal,
};
